import React from 'react';
interface InputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  rows?: number;
  className?: string;
}
export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  helperText,
  required = false,
  disabled = false,
  rows,
  className = ''
}: InputProps) {
  const isTextarea = type === 'textarea' || rows;
  const inputBaseStyles = 'w-full px-4 py-3 border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent';
  const inputStateStyles = error ? 'border-red-500 focus:ring-red-500' : 'border-neutral focus:border-primary';
  const disabledStyles = disabled ? 'bg-surface cursor-not-allowed' : 'bg-white';
  const InputElement = isTextarea ? 'textarea' : 'input';
  return <div className={`flex flex-col gap-1.5 ${className}`} data-id="element-81">
      <label className="text-sm font-semibold text-ink" data-id="element-82">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-83">*</span>}
      </label>

      <InputElement type={!isTextarea ? type : undefined} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} disabled={disabled} rows={isTextarea ? rows || 4 : undefined} className={`${inputBaseStyles} ${inputStateStyles} ${disabledStyles} ${isTextarea ? 'resize-y min-h-[100px]' : ''}`} data-id="element-84" />

      {helperText && !error && <p className="text-sm text-gray-600" data-id="element-85">{helperText}</p>}

      {error && <p className="text-sm text-red-500" data-id="element-86">{error}</p>}
    </div>;
}